var r = function (e) {
  return e.aboveLeft = "aboveLeft", e.aboveCenter = "aboveCenter", e.aboveRight = "aboveRight", e.underLeft = "underLeft", e.underCenter = "underCenter", e.underRight = "underRight", e.left = "left", e.right = "right", e;
}(r || {});

export { r as PositionVariants };